import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";
import {Provider} from "mobx-react";
import "@bezlimit/bezlimit-ui/dist/styles/index.min.css";
import "./styles/index.scss";
//components
import App from "./App";
// store
import Store from "./stores";
// core
import Interceptor from "./core/Interceptor";
//locale
import "moment/locale/ru";
import moment from "moment";
moment.locale("ru");

const Root = () => {
    return (
        <Provider store={Store}>
            <BrowserRouter>
                <Interceptor>
                    <App />
                </Interceptor>
            </BrowserRouter>
        </Provider>
    );
};

ReactDOM.render(<Root />, document.getElementById("root"));
